import { __makeTemplateObject } from "tslib";
import { css } from '../styled-components';
/**
 * apply flex center style
 *
 * ```
 * // display: flex;
 * // justify-content: center;
 * // align-items: center;
 * ```
 */
export var flexCenterStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var templateObject_1;
